<template>
	<div class="modal-overlay">
		<div class="modal-content">
			<div class="modal-header">
				<h5>Grocery List</h5>
				<button @click="close">&times;</button>
			</div>
			<div class="modal-body">
				<ul>
					<li v-for="item in list" :key="item">
						{{ item.item }} x {{ item.qty }}
					</li>
				</ul>
			</div>
			<div class="modal-footer">
				<button @click="close">Close</button>
				<button @click="printList">Print</button>
			</div>
		</div>
	</div>
</template>

<script setup>
	const props = defineProps({
		list: Array,
	})

	const emits = defineEmits(["close"])

	function close() {
		emits("close")
	}

	const printList = () => {
		// Assuming you have a prop called 'list' which is an array of grocery items
		const groceryListHTML = `
    <html>
      <head>
        <title>Grocery List</title>
        <style>
          body { font-family: Arial, sans-serif; }
          ul { list-style-type: none; }
          li { margin-bottom: 10px; }
          /* Add more styles as needed */
        </style>
      </head>
      <body>
        <h2>Grocery List</h2>
        <ul>
          ${props.list
						.map((item) => `<li>${item.qty} x ${item.item}</li>`)
						.join("")}
        </ul>
      </body>
    </html>
  `

		// Open a new tab/window
		const printWindow = window.open("", "_blank")

		// Write the HTML to the new tab
		printWindow.document.write(groceryListHTML)

		// Wait for the content to fully load
		printWindow.document.close() // Ensure the document is fully loaded
		printWindow.focus() // Necessary for some browsers to focus the new tab

		// Trigger the print dialog
		printWindow.print()

		// Close the new tab after a delay to give time for the print dialog
		setTimeout(function () {
			printWindow.close()
		}, 1000) // Adjust delay as needed
	}
</script>

<style lang="less" scoped>
	@modal-background-color: white;
	@overlay-color: rgba(0, 0, 0, 0.5);
	@primary-color: #007bff;
	@hover-color: #0056b3;

	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: @overlay-color;
		display: flex;
		justify-content: center;
		align-items: center;

		.modal-content {
			background: @modal-background-color;
			padding: 20px;
			border-radius: 5px;
			width: 90%;
			max-width: 500px;
			display: flex; /* Added to facilitate flexbox layout */
			flex-direction: column; /* Makes the children (header, body, footer) stack vertically */
			height: auto; /* Adjusts height automatically based on content */
			max-height: 80vh; /* Limits the maximum height to 80% of the viewport height */

			.modal-header,
			.modal-footer {
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #eee;
				padding-bottom: 10px;

				&:last-child {
					border-top: 1px solid #eee;
					padding-top: 10px;
					border-bottom: none;
					padding-bottom: 0;
				}
			}

			.modal-body {
				margin-top: 20px;
				margin-bottom: 20px;
				overflow-y: auto; /* Enables vertical scrolling */
				flex-grow: 1; /* Allows the body to expand to fill available space */
			}

			button {
				cursor: pointer;
				background-color: @primary-color;
				color: white;
				border: none;
				border-radius: 5px;
				padding: 10px 20px;
				margin-left: 10px;

				&:hover {
					background-color: @hover-color;
				}

				&.close {
					border: none;
					background: none;
					padding: 0;
					font-size: 1.5rem;
				}
			}
		}
	}
</style>
